module.exports = __webpack_public_path__ + "img/dataservice.ed32d9d.png";